export default {
  addEmployeeCourse: () => `/employee-courses`,
  addEmployeeCourseGroup: () => `/employee-courses/group`,
  updateEmployeeCourse: () => `/employee-courses`,
  deleteEmployeeCourse: id => `/employee-courses/${id}`,
  getEmployeeCourses: id => `/employee-courses/employee/${id}/courses`,
  getEmployeeCourseById: id => `/employee-courses/${id}`,
  getEmployeesByCourse: id => `/employee-courses/course/${id}/employees`,
};
